// @ts-nocheck
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FiRefreshCcw, FiTerminal } from "react-icons/fi";
import NoctisStatusDot from "../../components/noctis/NoctisStatusDot";
import { LdsOverviewHero, LdsOverviewPage } from "../../components/lds/LdsOverview";
import { integrationApi } from "../../api/apiClient";

const NoctisConsole = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const fetchObjectTypes = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    const timestamp = new Date().toISOString();
    try {
      const res = await integrationApi.get("/integration/object-types");
      setResult({
        ok: true,
        timestamp,
        status: res?.status,
        data: res?.data,
      });
    } catch (e) {
      setResult({ ok: false, timestamp, status: e?.response?.status ?? null, data: e?.response?.data });
      setError(e?.message || "Request failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LdsOverviewPage>
      <LdsOverviewHero
        icon={FiTerminal}
        eyebrow={t("noctis.menu", { defaultValue: "Noctis" })}
        title={t("noctis.console.title")}
        description={t("noctis.console.description")}
        actions={
          <>
            <NoctisStatusDot />
            <button
              type="button"
              onClick={fetchObjectTypes}
              className="inline-flex items-center gap-2 rounded-full bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-60"
              disabled={loading}
            >
              <FiRefreshCcw />
              {loading ? t("common.loading", { defaultValue: "Loading..." }) : t("noctis.refresh")}
            </button>
          </>
        }
      />
      <div className="space-y-6 text-gray-900 dark:text-gray-100">
        <div className="rounded-[24px] border border-slate-200 bg-white p-6 shadow-sm dark:border-white/10 dark:bg-slate-900/80">
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div className="max-w-3xl">
              <h2 className="text-xl font-semibold text-indigo-900 dark:text-indigo-100 flex items-center gap-2">
                <FiTerminal />
                {t("noctis.console.subtitle")}
              </h2>
              <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">{t("noctis.console.description")}</p>
            </div>
          </div>

          {error && (
            <div className="mt-4 rounded-2xl border border-red-200/80 bg-red-50/90 px-4 py-3 text-sm text-red-800 shadow-sm dark:border-red-500/40 dark:bg-red-900/40 dark:text-red-100">
              {error}
            </div>
          )}
        </div>

        <div className="rounded-[24px] border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-slate-900/80">
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-lg font-semibold text-indigo-900 dark:text-indigo-100">
              {t("noctis.console.last_result")}
            </h3>
            {result?.timestamp && (
              <span className="text-xs text-gray-500 dark:text-gray-400">{result.timestamp}</span>
            )}
          </div>

          {!result && (
            <p className="text-sm text-gray-600 dark:text-gray-300">
              {t("noctis.console.no_result")}
            </p>
          )}

          {result && (
            <div className="overflow-hidden rounded-xl border border-gray-200 dark:border-gray-800">
              <div
                className={`flex items-center gap-3 px-4 py-2 text-sm font-semibold ${
                  result.ok
                    ? "bg-emerald-50 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-100"
                    : "bg-red-50 text-red-800 dark:bg-red-900/30 dark:text-red-100"
                }`}
              >
                <span>{result.ok ? "OK" : "Error"}</span>
                {typeof result.status === "number" && <span className="text-xs">HTTP {result.status}</span>}
              </div>
              <pre className="max-h-[520px] overflow-auto bg-gray-900 text-gray-100 p-4 text-xs whitespace-pre-wrap break-words">
                {JSON.stringify(result.data, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </div>
    </LdsOverviewPage>
  );
};

export default NoctisConsole;
